export default __webpack_public_path__ + "static/media/error.bc754a5b.svg";